import type { QueryClient } from '@tanstack/react-query';
import type { ProfileDto } from '@paladin-monorepo/common';

export const PROFILE_QUERY_KEY = ['profile'] as const;

export function setProfileQueryData(queryClient: QueryClient, profile: ProfileDto): void {
  queryClient.setQueryData(PROFILE_QUERY_KEY, profile);
}

export function invalidateProfileQuery(queryClient: QueryClient): Promise<void> {
  return queryClient.invalidateQueries({ queryKey: PROFILE_QUERY_KEY });
}

/** Apply PATCH /me/profile (or photo upload) response so completeness updates immediately. */
export function onProfileMutationSuccess(
  queryClient: QueryClient,
  profile: ProfileDto,
): void {
  setProfileQueryData(queryClient, profile);
}
